import validationMessages from 'vee-validate/dist/locale/es'

const messages = {
  form: {
    validation: {
      messages: {
        ...validationMessages.messages,
        required: '(*) Requerido',
        confirmed: 'Las contraseñas no coinciden'
      },
    },
  },
  recoveryPassword: {
    // El backend ya no dice si el correo existe (responde 200 siempre): esto
    // queda para cuando la solicitud falla.
    requestFailed: 'No pudimos procesar la solicitud. Inténtalo de nuevo en unos minutos.'
  }
}

export default messages
